// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"70c67edd","168":"fddfa243","232":"0213d755","260":"dac86bde","453":"2306fbd0","587":"84064a5b","622":"f1898898","667":"7806ed3d","729":"b83e40d5","842":"f5cc0703","910":"d905923a","938":"9ac25982"}[chunkId] + ".chunk.js";
};